import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/empresaCat`;

export default class EmpresaCatService{
	static async filtrarEmpresas(query) {
		return axios.get(URL_BASE + "/filtrarEmpresas?query=" + query);
	}
}



// WEBPACK FOOTER //
// ./src/service/EmpresaCatService.js